import styled from "styled-components";

const WidgetFrameFiltersStyled = styled.div`
    padding: 0rem 1.5rem 1rem 1.5rem;
`;

type Props = {
    children?: React.ReactNode;
};

const WidgetFrameFilters = (props: Props) => {
    const { children } = props;

    return <WidgetFrameFiltersStyled>{children}</WidgetFrameFiltersStyled>;
};

export { WidgetFrameFilters };
